import React, { useEffect, useState } from 'react';
import { PAGE_NUDGES } from '../../data/pageNudges';
import { buildRoute } from '../../utils/projectNavManifest';

/**
 * DP278-C6c-1 — one quiet line at the top of a page, in the page's own words.
 * It turns into a pointer when the page's input is missing, and it fades to the
 * lighter tone once the same person has read it on five projects.
 */
const SEEN_MAX = 5;

const seenKey = (testId) => `km_nudge_seen:${testId}`;

const readSeen = (testId) => {
  try {
    const raw = JSON.parse(localStorage.getItem(seenKey(testId)) || '[]');
    return Array.isArray(raw) ? raw : [];
  } catch (e) {
    return [];
  }
};

const rememberSeen = (testId, projectId) => {
  const ids = readSeen(testId);
  if (!projectId || ids.includes(projectId)) return ids;
  const next = [...ids, projectId];
  try {
    localStorage.setItem(seenKey(testId), JSON.stringify(next));
  } catch (e) { /* storage is a courtesy, never a requirement */ }
  return next;
};

export const PageNudge = ({ testId, projectId, columnState, onTab, onRoute }) => {
  const row = PAGE_NUDGES.find((n) => n.testId === testId);
  const [seen, setSeen] = useState(false);

  useEffect(() => {
    if (!testId) return;
    setSeen(rememberSeen(testId, projectId).length >= SEEN_MAX);
  }, [testId, projectId]);

  if (!row) return null;

  const missing = !!row.input && columnState?.inputs?.[row.input] === 0;
  if (missing) {
    const go = () => {
      if (String(row.to || '').startsWith('/')) onRoute?.(buildRoute(projectId, row.to));
      else onTab?.(row.to);
    };
    return (
      <div className="kpd-nudge point" data-testid={`nudge-${testId}`}>
        <span>{row.pointer}</span>
        <button type="button" onClick={go}>{row.label} →</button>
      </div>
    );
  }
  return (
    <div className={`kpd-nudge${seen ? ' seen' : ''}`} data-testid={`nudge-${testId}`}>
      <span>{row.nudge}</span>
    </div>
  );
};

export default PageNudge;
